// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportPartPropsFormSchema.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

import localizer from 'share/localization/Izenda.Localizer';
import { MESSAGE } from './Izenda.PropertiesBuilderConstants';

export default {
  schemaKey: 'RP_FORM_TYPE',
  fields: {
    form: {
      component: 'Panel',
      isHidden: 'isNotShow',
      props: {
        initState: true,
        collapsible: true,
        header: {
          get title() {
            return localizer.getText('COMMON_LABEL_FORM');
          },
          icon: 'icon-toggle-triangle'
        }
      },
      fields: {
        border: {
          get title() {
            return localizer.getText('COMMON_LABEL_BORDER');
          },
          type: 'btnPopup',
          fnValue: 'getBorderSettings',
          props: {
            hadSetting: 'hadSettingBorder',
            fnResetDefaultValue: 'fnResetBorderDefaultValue',
            loadValue: 'getBorderSettings'
          },
          staticProps: {
            get title() {
              return localizer.getText('REPORT_PART_PROPS_FORM_SCHEMA_FORM_BORDER_SETTINGS');
            },
            className: 'icon-setting btn-icon',
            get popupTitle() {
              return localizer.getText('REPORT_PART_PROPS_FORM_SCHEMA_FORM_BORDER_SETTINGS');
            },
            popupContent: require('modules/ReportDesigner/Fields/ReportBody/ReportPartType/ReportPartForm/Izenda.FormBorderSettings'),
            popupProps: {
              type: 'none'
            }
          }
        },

        backgroundColor: {
          get title() {
            return localizer.getText('COLOR_STYLING_BACKGROUND_TOOLTIP');
          },
          type: 'color',
          fnValue: 'getBackgroundColor',
          props: {
            get title() {
              return localizer.getText('REPORT_PART_PROPS_FORM_SCHEMA_BACKGROUND_COLOR_SETTINGS');
            },
            position: 'left',
            hadSetting: 'hadSettingBackgroundColor',
            loadValue: 'getBackgroundColor'
          }
        }
      }
    },
    edit: {
      component: 'Panel',
      isHidden: 'isViewFrontSide',
      props: {
        initState: true,
        collapsible: true,
        header: {
          get title() {
            return localizer.getText('COMMON_LABEL_EDIT');
          },
          icon: 'icon-toggle-triangle'
        }
      },
      fields: {
        toolbar: {
          get title() {
            return localizer.getText('REPORT_PART_PROPS_FORM_SCHEMA_TOOL_BAR');
          },
          component: 'ButtonGroup',
          fnValue: 'getToolbarSetting',
          props: {
            editorControl: 'getEditorControl',
            buttonsHidden: 'getEditButtonHidden',
            buttons: {
              cut: {
                className: 'icon-cut',
                get title() {
                  return localizer.getText('REPORT_PART_PROPS_FORM_SCHEMA_CUT');
                },
                value: 'Cut',
                isExecute: true
              },
              copy: {
                className: 'icon-copy',
                get title() {
                  return localizer.getText('REPORT_PART_PROPS_FORM_SCHEMA_COPY');
                },
                value: 'Copy',
                isExecute: true
              },
              paste: {
                className: 'icon-paste',
                get title() {
                  return localizer.getText('REPORT_PART_PROPS_FORM_SCHEMA_PASTE');
                },
                value: 'Paste',
                isExecute: true
              },
              pasteAsText: {
                className: 'icon-pastetext',
                get title() {
                  return localizer.getText('REPORT_PART_PROPS_FORM_SCHEMA_PASTE_AS_TEXT');
                },
                value: 'pasteAsText',
                breakLine: true
              },
              selectAll: {
                className: 'icon-select-all',
                get title() {
                  return localizer.getText('REPORT_PART_PROPS_FORM_SCHEMA_SELECT_ALL');
                },
                value: 'selectAll',
                isExecute: true
              },
              searchReplace: {
                className: 'icon-search-replace',
                get title() {
                  return localizer.getText('REPORT_PART_PROPS_FORM_SCHEMA_FIND_AND_REPLACE_SHORT_CUT');
                },
                value: 'SearchReplace',
                isExecute: true
              },
              searchReplaceHTML: {
                component: require('modules/ReportDesigner/Fields/ReportBody/ReportPartType/ReportPartForm/Izenda.FormSearchPopup'),
                className: 'icon-search-replace',
                get title() {
                  return localizer.getText('REPORT_PART_PROPS_FORM_SCHEMA_FIND_AND_REPLACE');
                }
              },
              undo: {
                className: 'icon-back',
                get title() {
                  return localizer.getText('REPORT_PART_PROPS_FORM_SCHEMA_UNDO');
                },
                value: 'Undo',
                isExecute: true
              },
              redo: {
                className: 'icon-next',
                get title() {
                  return localizer.getText('REPORT_PART_PROPS_FORM_SCHEMA_REDO');
                },
                value: 'Redo',
                isExecute: true
              }
            }
          }
        }
      }
    },
    insert: {
      component: 'Panel',
      isHidden: 'isInsertHidden',
      props: {
        initState: true,
        collapsible: true,
        header: {
          get title() {
            return localizer.getText('COMMON_LABEL_INSERT');
          },
          icon: 'icon-toggle-triangle'
        }
      },
      fields: {
        item: {
          get title() {
            return localizer.getText('REPORT_PART_PROPS_FORM_SCHEMA_ITEM');
          },
          component: 'ButtonGroup',
          isHidden: 'isActiveForEdit',
          props: {
            editorControl: 'getEditorControl',
            buttons: {
              link: {
                className: 'icon-link',
                get title() {
                  return localizer.getText('REPORT_PART_PROPS_FORM_SCHEMA_INSERT_EDIT_LINK');
                },
                value: 'mceLink',
                isExecute: true
              },
              image: {
                className: 'icon-img',
                get title() {
                  return localizer.getText('REPORT_PART_PROPS_FORM_SCHEMA_INSERT_EDIT_IMAGE');
                },
                value: 'mceImage',
                isExecute: true
              },
              anchor: {
                className: 'icon-anchor',
                get title() {
                  return localizer.getText('REPORT_PART_PROPS_FORM_SCHEMA_INSERT_EDIT_ANCHOR');
                },
                value: 'mceAnchor',
                isExecute: true
              },
              charmap: {
                className: 'icon-special',
                get title() {
                  return localizer.getText('REPORT_PART_PROPS_FORM_SCHEMA_INSERT_SPECIAL_CHARACTER');
                },
                value: 'mceShowCharmap',
                isExecute: true,
                breakLine: true
              },
              insertDate: {
                className: 'icon-calendar',
                get title() {
                  return localizer.getText('REPORT_PART_PROPS_FORM_SCHEMA_INSERT_DATE_TIME_VALUE');
                },
                value: 'mceInsertDate',
                isExecute: true
              },
              insertRule: {
                className: 'icon-line',
                get title() {
                  return localizer.getText('REPORT_PART_PROPS_FORM_SCHEMA_HORIZONTAL_LINE');
                },
                value: 'InsertHorizontalRule',
                isExecute: true
              },
              pageBreak: {
                className: 'icon-seperate',
                get title() {
                  return localizer.getText('REPORT_PART_PROPS_FORM_SCHEMA_INSERT_PAGE_BREAK');
                },
                value: 'mcePageBreak',
                isExecute: true
              },
              template: {
                className: 'icon-temp',
                get title() {
                  return localizer.getText('REPORT_PART_PROPS_FORM_SCHEMA_INSERT_TEMPLATE_BREAK');
                },
                value: 'mceTemplateEmpty'
              }
            }
          }
        },
        field: {
          get title() {
            return localizer.getText('COMMON_LABEL_FIELD');
          },
          type: 'btnPopup',
          fnValue: 'getFieldQuerySource',
          props: {
            beforeOnChange: 'beforeAddField',
            loadValue: 'getFieldQuerySource'
          },
          staticProps: {
            get title() {
              return localizer.getText('REPORT_PART_PROPS_FORM_SCHEMA_ADD_FIELD');
            },
            className: 'icon-plus-circled btn-icon',
            get popupTitle() {
              return localizer.getText('REPORT_PART_PROPS_FORM_SCHEMA_FIELD_SELECTION');
            },
            popupContent: require('modules/ReportDesigner/Fields/ReportBody/ReportPartType/ReportPartForm/Izenda.SelectionField'),
            popupProps: {
              type: 'none',
              containerClass: 'izenda-SelectionFieldPopup'
            }
          }
        },
        smartTag: {
          get title() {
            return localizer.getText('REPORT_PART_PROPS_FORM_SCHEMA_SMART_TAG');
          },
          component: 'ButtonGroup',
          fnValue: 'getGeneralInfoByKey',
          props: {
            editorControl: 'getEditorControl',
            buttons: {
              smartTag: {
                type: 'smartTag',
                component: require('modules/ReportDesigner/Fields/ReportBody/ReportPartType/ReportPartForm/Izenda.SmartTag'),
                className: 'icon-tag',
                get title() {
                  return localizer.getText('REPORT_PART_PROPS_FORM_SCHEMA_SMART_TAG');
                }
              }
            }
          }
        },
        repeater: {
          get title() {
            return localizer.getText('REPORT_PART_PROPS_FORM_SCHEMA_REPEATER');
          },
          component: 'ButtonGroup',
          fnValue: 'getFormatDateByKey',
          props: {
            editorControl: 'getEditorControl',
            buttons: {
              repeater: {
                type: 'repeater',
                component: require('modules/ReportDesigner/Fields/ReportBody/ReportPartType/ReportPartForm/Izenda.IconDropdownSetting'),
                className: 'icon-repeat',
                get title() {
                  return localizer.getText('REPORT_PART_PROPS_FORM_SCHEMA_INSERT_REPEATER');
                }
              }
            }
          }
        },
        embedReport: {
          get title() {
            return localizer.getText('COMMON_LABEL_EMBEDDED_REPORT_SETTINGS');
          },
          type: 'btnPopup',
          props: {
            reportId: 'getReportId'
          },
          staticProps: {
            get title() {
              return localizer.getText('COMMON_LABEL_EMBEDDED_REPORT_SETTINGS');
            },
            className: 'btn-icon icon-embed',
            get popupTitle() {
              return localizer.getText('COMMON_LABEL_EMBEDDED_REPORT_SETTINGS');
            },
            popupContent: require('modules/ReportDesigner/Fields/ReportBody/ReportPartType/ReportPartForm/Izenda.EmbedReport'),
            popupProps: {
              type: 'none',
              autoClose: false
            }
          }
        }
      }
    },
    format: {
      component: 'Panel',
      isHidden: 'isActiveForEdit',
      props: {
        initState: true,
        collapsible: true,
        header: {
          get title() {
            return localizer.getText('COMMON_LABEL_FORMAT');
          },
          icon: 'icon-toggle-triangle'
        }
      },
      fields: {
        heading: {
          get title() {
            return localizer.getText('COMMON_LABEL_HEADING');
          },
          component: 'ButtonGroup',
          fnValue: 'getFormatDateByKey',
          props: {
            editorControl: 'getEditorControl',
            buttons: {
              heading: {
                type: 'heading',
                component: require('modules/ReportDesigner/Fields/ReportBody/ReportPartType/ReportPartForm/Izenda.IconDropdownSetting'),
                className: 'icon-heading',
                get title() {
                  return localizer.getText('COMMON_LABEL_HEADING');
                }
              }
            }
          }
        },
        block: {
          get title() {
            return localizer.getText('REPORT_PART_PROPS_FORM_SCHEMA_BLOCKS');
          },
          component: 'ButtonGroup',
          fnValue: 'getFormatDateByKey',
          props: {
            editorControl: 'getEditorControl',
            buttons: {
              block: {
                type: 'block',
                component: require('modules/ReportDesigner/Fields/ReportBody/ReportPartType/ReportPartForm/Izenda.IconDropdownSetting'),
                className: 'icon-block',
                get title() {
                  return localizer.getText('REPORT_PART_PROPS_FORM_SCHEMA_BLOCKS');
                }
              }
            }
          }
        },
        font: {
          get title() {
            return localizer.getText('FONT_SETTINGS_LABEL_FONT');
          },
          component: require('modules/ReportDesigner/Fields/ReportBody/ReportPartType/ReportPartForm/Izenda.FormFontSettings'),
          fnValue: 'getFormatDateByKey',
          props: {
            editorControl: 'getEditorControl',
            buttons: {
              script: {
                superscript: {
                  className: 'icon-upno',
                  get title() {
                    return localizer.getText('REPORT_PART_PROPS_FORM_SCHEMA_SUPERSCRIPT');
                  },
                  value: 'superscript'
                },
                subscript: {
                  className: 'icon-dono',
                  get title() {
                    return localizer.getText('REPORT_PART_PROPS_FORM_SCHEMA_SUBSCRIPT');
                  },
                  value: 'subscript'
                }
              },
              default: {
                bold: {
                  className: 'u_textBold',
                  get title() {
                    return localizer.getText('FONT_STYLE_BOLD_TOOLTIP');
                  },
                  value: 'bold',
                  text: 'B'
                },
                italic: {
                  className: 'u_textItalic',
                  get title() {
                    return localizer.getText('FONT_STYLE_ITALIC_TOOLTIP');
                  },
                  value: 'italic',
                  text: 'I'
                },
                underline: {
                  className: 'u_textUnderline',
                  get title() {
                    return localizer.getText('FONT_STYLE_UNDERLINE_TOOLTIP');
                  },
                  value: 'underline',
                  text: 'U'
                },
                strikethrough: {
                  className: 'icon-del-text',
                  get title() {
                    return localizer.getText('COMMON_LABEL_STRIKETHROUGH');
                  },
                  value: 'strikethrough'
                }
              },
              codeScript: {
                code: {
                  className: 'icon-script',
                  get title() {
                    return localizer.getText('REPORT_PART_PROPS_FORM_SCHEMA_CODE');
                  },
                  value: 'code'
                }
              }
            }
          }
        },
        alignment: {
          get title() {
            return localizer.getText('FONT_SETTINGS_LABEL_ALIGNMENT');
          },
          component: 'ButtonGroup',
          fnValue: 'getFormatDateByKey',
          props: {
            editorControl: 'getEditorControl',
            buttons: {
              alignleft: {
                className: 'icon-align-left',
                get title() {
                  return localizer.getText('COMMON_LABEL_ALIGN_LEFT');
                },
                value: 'JustifyLeft',
                isExecute: true
              },
              aligncenter: {
                className: 'icon-align-center',
                get title() {
                  return localizer.getText('COMMON_LABEL_ALIGN_CENTER');
                },
                value: 'JustifyCenter',
                isExecute: true
              },
              alignright: {
                className: 'icon-align-right',
                get title() {
                  return localizer.getText('COMMON_LABEL_ALIGN_RIGHT');
                },
                value: 'JustifyRight',
                isExecute: true
              },
              alignjustify: {
                className: 'icon-align-justify',
                get title() {
                  return localizer.getText('COMMON_LABEL_ALIGN_JUSTIFY');
                },
                value: 'JustifyFull',
                isExecute: true
              }
            }
          }
        },
        list: {
          get title() {
            return localizer.getText('REPORT_PART_PROPS_FORM_SCHEMA_LIST');
          },
          component: 'ButtonGroup',
          fnValue: 'getFormatDateByKey',
          props: {
            editorControl: 'getEditorControl',
            buttons: {
              bullet: {
                type: 'bullet',
                component: require('modules/ReportDesigner/Fields/ReportBody/ReportPartType/ReportPartForm/Izenda.IconDropdownSetting'),
                className: 'icon-list-bullet',
                get title() {
                  return localizer.getText('COMMON_LABEL_BULLET_LIST');
                }
              },
              numbered: {
                type: 'numbered',
                component: require('modules/ReportDesigner/Fields/ReportBody/ReportPartType/ReportPartForm/Izenda.IconDropdownSetting'),
                className: 'icon-numbered',
                get title() {
                  return localizer.getText('COMMON_LABEL_NUMBERED_LIST');
                }
              }
            }
          }
        },
        indent: {
          get title() {
            return localizer.getText('REPORT_PART_PROPS_FORM_SCHEMA_INDENT');
          },
          component: 'ButtonGroup',
          fnValue: 'getGeneralInfoByKey',
          props: {
            editorControl: 'getEditorControl',
            buttons: {
              indent: {
                className: 'icon-cl',
                get title() {
                  return localizer.getText('REPORT_PART_PROPS_FORM_SCHEMA_INCREASE_INDENT');
                },
                value: 'Indent',
                isExecute: true
              },
              outdent: {
                className: 'icon-ex',
                get title() {
                  return localizer.getText('REPORT_PART_PROPS_FORM_SCHEMA_DECREASE_INDENT');
                },
                value: 'Outdent',
                isExecute: true
              }
            }
          }
        },
        //noneditable: {
        //  get title() { return localizer.getText('REPORT_PART_PROPS_FORM_SCHEMA_NON_EDITABLE') },
        //  component: 'ButtonGroup',
        //  fnValue: 'getGeneralInfoByKey',
        //  props: {
        //    buttons: {
        //      noneditable: {
        //        className: 'icon-noedit',
        //        get title() { return localizer.getText('REPORT_PART_PROPS_FORM_SCHEMA_NON_EDITABLE') }
        //      }
        //    }
        //  }
        //},
        clearFormatting: {
          get title() {
            return localizer.getText('REPORT_PART_PROPS_FORM_SCHEMA_CLEAR_FORMATTING');
          },
          component: 'ButtonGroup',
          fnValue: 'getGeneralInfoByKey',
          props: {
            editorControl: 'getEditorControl',
            buttons: {
              removeFormat: {
                className: 'icon-clear',
                get title() {
                  return localizer.getText('REPORT_PART_PROPS_FORM_SCHEMA_CLEAR_FORMATTING');
                },
                value: 'RemoveFormat',
                isExecute: true
              }
            }
          }
        }
      }
    },
    table: {
      component: 'Panel',
      isHidden: 'isActiveForEdit',
      props: {
        initState: true,
        collapsible: true,
        header: {
          get title() {
            return localizer.getText('MODEL_LABEL_TABLE');
          },
          icon: 'icon-toggle-triangle'
        }
      },
      fields: {
        table: {
          get title() {
            return localizer.getText('MODEL_LABEL_TABLE');
          },
          component: 'ButtonGroup',
          props: {
            editorControl: 'getEditorControl',
            buttonsHidden: 'getTableButtonHidden',
            buttons: {
              insertTable: {
                component: require('modules/ReportDesigner/Fields/ReportBody/ReportPartType/ReportPartForm/Izenda.InsertTablePopup'),
                className: 'icon-table-new',
                get title() {
                  return localizer.getText('REPORT_PART_PROPS_FORM_SCHEMA_INSERT_TABLE');
                }
              },
              tableDelete: {
                className: 'icon-notable',
                get title() {
                  return localizer.getText('REPORT_PART_PROPS_FORM_SCHEMA_DELETE_TABLE');
                },
                value: 'mceTableDelete',
                isExecute: true
              },
              tableProperties: {
                className: 'icon-setting',
                get title() {
                  return localizer.getText('REPORT_PART_PROPS_FORM_SCHEMA_TABLE_PROPERTIES');
                },
                value: 'mceInsertTable',
                isExecute: true
              }
            }
          }
        },
        cell: {
          get title() {
            return localizer.getText('REPORT_PART_PROPS_FORM_SCHEMA_CELL');
          },
          component: 'ButtonGroup',
          isHidden: 'isHiddenTableCell',
          props: {
            editorControl: 'getEditorControl',
            buttons: {
              cellProp: {
                className: 'icon-setting',
                get title() {
                  return localizer.getText('REPORT_PART_PROPS_FORM_SCHEMA_CELL_PROPERTIES');
                },
                value: 'mceTableCellProps',
                isExecute: true
              },
              mergeCells: {
                className: 'icon-rcell-icon',
                get title() {
                  return localizer.getText('REPORT_PART_PROPS_FORM_SCHEMA_MERGE_CELL');
                },
                value: 'mceTableMergeCells',
                isExecute: true
              },
              splitCell: {
                className: 'icon-acell',
                get title() {
                  return localizer.getText('REPORT_PART_PROPS_FORM_SCHEMA_SPLIT_CELL');
                },
                value: 'mceTableSplitCells',
                isExecute: true
              }
            }
          }
        },
        row: {
          get title() {
            return localizer.getText('REPORT_PART_PROPS_FORM_SCHEMA_ROW');
          },
          component: 'ButtonGroup',
          isHidden: 'isHiddenTableCell',
          props: {
            editorControl: 'getEditorControl',
            buttons: {
              rowBefore: {
                className: 'icon-addup',
                get title() {
                  return localizer.getText('REPORT_PART_PROPS_FORM_SCHEMA_INSERT_ROW_BEFORE');
                },
                value: 'mceTableInsertRowBefore',
                isExecute: true
              },
              rowAfter: {
                className: 'icon-adddo',
                get title() {
                  return localizer.getText('REPORT_PART_PROPS_FORM_SCHEMA_INSERT_ROW_AFTER');
                },
                value: 'mceTableInsertRowAfter',
                isExecute: true
              },
              deleteRow: {
                className: 'icon-remove-cell',
                get title() {
                  return localizer.getText('REPORT_PART_PROPS_FORM_SCHEMA_INSERT_DELETE_ROW');
                },
                value: 'mceTableDeleteRow',
                isExecute: true
              },
              rowProperties: {
                className: 'icon-setting',
                get title() {
                  return localizer.getText('REPORT_PART_PROPS_FORM_SCHEMA_ROW_PROPERTIES');
                },
                value: 'mceTableRowProps',
                isExecute: true,
                breakLine: true
              },
              cutRow: {
                className: 'icon-cut',
                get title() {
                  return localizer.getText('REPORT_PART_PROPS_FORM_SCHEMA_CUT_ROW');
                },
                value: 'mceTableCutRow',
                isExecute: true
              },
              copyRow: {
                className: 'icon-copy-new',
                get title() {
                  return localizer.getText('REPORT_PART_PROPS_FORM_SCHEMA_COPY_ROW');
                },
                value: 'mceTableCopyRow',
                isExecute: true
              },
              pasteRowBefore: {
                className: 'icon-paste',
                get title() {
                  return localizer.getText('REPORT_PART_PROPS_FORM_SCHEMA_PASTE_ROW_BEFORE');
                },
                value: 'mceTablePasteRowBefore',
                isExecute: true
              },
              pasteRowAfter: {
                className: 'icon-pastetext',
                get title() {
                  return localizer.getText('REPORT_PART_PROPS_FORM_SCHEMA_PASTE_ROW_AFTER');
                },
                value: 'mceTablePasteRowAfter',
                isExecute: true
              }
            }
          }
        },
        column: {
          get title() {
            return localizer.getText('COMMON_LABEL_COLUMN');
          },
          component: 'ButtonGroup',
          isHidden: 'isHiddenTableCell',
          props: {
            editorControl: 'getEditorControl',
            buttons: {
              insertColumnBefore: {
                className: 'icon-addle-icon',
                get title() {
                  return localizer.getText('REPORT_PART_PROPS_FORM_SCHEMA_INSERT_COLUMN_BEFORE');
                },
                value: 'mceTableInsertColBefore',
                isExecute: true
              },
              insertColumnAfter: {
                className: 'icon-addri',
                get title() {
                  return localizer.getText('REPORT_PART_PROPS_FORM_SCHEMA_INSERT_COLUMN_AFTER');
                },
                value: 'mceTableInsertColAfter',
                isExecute: true
              },
              deleteColumn: {
                className: 'icon-remove-row',
                get title() {
                  return localizer.getText('REPORT_PART_PROPS_FORM_SCHEMA_DELETE_COLUMN');
                },
                value: 'mceTableDeleteCol',
                isExecute: true
              }
            }
          }
        }
      }
    },
    tool: {
      component: 'Panel',
      props: {
        initState: true,
        collapsible: true,
        header: {
          get title() {
            return localizer.getText('REPORT_PART_PROPS_FORM_SCHEMA_TOOL');
          },
          icon: 'icon-toggle-triangle'
        }
      },
      fields: {
        directionality: {
          get title() {
            return localizer.getText('REPORT_PART_PROPS_FORM_SCHEMA_DIRECTIONALITY');
          },
          component: 'ButtonGroup',
          isHidden: 'isViewFrontSide',
          fnValue: 'getDirectionSetting',
          props: {
            editorControl: 'getEditorControl',
            buttons: {
              rightToLeft: {
                className: 'icon-rblock',
                get title() {
                  return localizer.getText('REPORT_PART_PROPS_FORM_SCHEMA_RIGHT_TO_LEFT');
                },
                value: 'mceDirectionRTL',
                isExecute: true
              },
              leftToRight: {
                className: 'icon-lblock',
                get title() {
                  return localizer.getText('REPORT_PART_PROPS_FORM_SCHEMA_LEFT_TO_RIGHT');
                },
                value: 'mceDirectionLTR',
                isExecute: true
              }
            }
          }
        }
      }
    },
    html: {
      component: 'Panel',
      isHidden: 'isHiddenHTMLCode',
      props: {
        initState: true,
        collapsible: true,
        header: {
          title: 'HTML',
          icon: 'icon-toggle-triangle'
        }
      },
      fields: {
        wrapText: {
          get title() {
            return localizer.getText('REPORT_PART_PROPS_FORM_SCHEMA_WRAP_TEXT');
          },
          type: 'checkbox',
          fnValue: 'getWrapTextValue'
        },
        highlightCode: {
          get title() {
            return localizer.getText('REPORT_PART_PROPS_FORM_SCHEMA_HIGHTLIGHT_CODE');
          },
          type: 'checkbox',
          fnValue: 'getHightlightCodeValue'
        },
        reformat: {
          get title() {
            return localizer.getText('REPORT_PART_PROPS_FORM_SCHEMA_REFORMAT');
          },
          component: 'ButtonGroup',
          props: {
            editorControl: 'getEditorControl',
            buttons: {
              reformat: {
                className: 'icon-reformat',
                get title() {
                  return localizer.getText('REPORT_PART_PROPS_FORM_SCHEMA_REFORMAT');
                },
                value: 'Reformat',
                isExecute: true
              }
            }
          }
        }
      }
    },
    view: {
      component: 'Panel',
      props: {
        initState: true,
        collapsible: true,
        header: {
          get title() {
            return localizer.getText('MODEL_LABEL_VIEW');
          },
          icon: 'icon-toggle-triangle'
        }
      },
      fields: {
        showInvisibleCharacters: {
          get title() {
            return localizer.getText('REPORT_PART_PROPS_FORM_SCHEMA_SHOW_INVISIBLE_CHARACTERS');
          },
          type: 'checkbox',
          fnValue: 'getShowInvisibleCharacters'
        },
        visualAids: {
          get title() {
            return localizer.getText('REPORT_PART_PROPS_FORM_SCHEMA_SHOW_VISUAL_AIDS');
          },
          type: 'checkbox',
          fnValue: 'getVisualAids'
        },
        dataRefreshInterval: {
          get title() {
            return localizer.getText('COMMON_LABEL_DATA_REFRESH_INTERVAL_SETTING');
          },
          type: 'btnPopup',
          fnValue: 'getDataRefreshInterval',
          props: {
            hadSetting: 'hadRefreshInterval',
            fnResetDefaultValue: 'fnResetRefreshIntervalDefaultValue',
            loadValue: 'getDataRefreshInterval'
          },
          staticProps: {
            get title() {
              return localizer.getText('COMMON_LABEL_DATA_REFRESH_INTERVAL_SETTING');
            },
            className: 'icon-setting btn-icon',
            get popupTitle() {
              return localizer.getText('COMMON_LABEL_DATA_REFRESH_INTERVAL_SETTING');
            },
            popupContent: require('modules/ReportDesigner/Fields/PropertiesBuilder/Izenda.DataRefreshSetting'),
            popupProps: {
              type: 'none',
              autoClose: false
            }
          }
        },
        usePagination: {
          get title() {
            return localizer.getText('COMMON_LABEL_USE_PAGINATION');
          },
          type: 'checkbox',
          fnValue: 'getUsePagination'
        }
      }
    }
  }
};



// WEBPACK FOOTER //
// ./ui/logic/data/Izenda.ReportPartPropsFormSchema.js